webpackJsonp([1],{

/***/ 1:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_bus__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modal_wrapper__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modal__ = __webpack_require__(6);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__modal_wrapper__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__modal__["a"]; });
/* unused harmony reexport Bus */




var VuModal = {};
VuModal.install = function (Vue) {
  Vue.prototype.$modals = new Vue({
    name: '$modals',

    created: function created() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__utils_bus__["a" /* default */].$on('opened', function (data) {
        _this.$emit('modals:opened', data);
      });

      __WEBPACK_IMPORTED_MODULE_0__utils_bus__["a" /* default */].$on('closed', function (data) {
        _this.$emit('modals:closed', data);
      });

      __WEBPACK_IMPORTED_MODULE_0__utils_bus__["a" /* default */].$on('destroyed', function (data) {
        _this.$emit('modals:destroyed', data);
      });

      this.$on('new', function (options) {
        _this.open(options);
      });

      this.$on('close', function (data) {
        _this.close(data);
      });

      this.$on('dismiss', function (index) {
        _this.dismiss(index || null);
      });
    },


    methods: {
      open: function open() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

        __WEBPACK_IMPORTED_MODULE_0__utils_bus__["a" /* default */].$emit('new', options);
      },
      close: function close() {
        var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

        __WEBPACK_IMPORTED_MODULE_0__utils_bus__["a" /* default */].$emit('close', data);
      },
      dismiss: function dismiss() {
        var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

        __WEBPACK_IMPORTED_MODULE_0__utils_bus__["a" /* default */].$emit('dismiss', index);
      }
    }
  });

  Vue.mixin({
    created: function created() {
      this.$on('modals:new', function (options) {
        __WEBPACK_IMPORTED_MODULE_0__utils_bus__["a" /* default */].$emit('new', options);
      });

      this.$on('modals:close', function (data) {
        __WEBPACK_IMPORTED_MODULE_0__utils_bus__["a" /* default */].$emit('close', data);
      });

      this.$on('modals:dismiss', function (index) {
        __WEBPACK_IMPORTED_MODULE_0__utils_bus__["a" /* default */].$emit('dismiss', index);
      });
    }
  });
};

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(VuModal);
}

/* harmony default export */ __webpack_exports__["a"] = (VuModal);



/***/ }),

/***/ 10:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'page-row',
  functional: true,
  props: {
    title: {
      type: String,
      default: ''
    },
    margin: {
      type: Number,
      default: 0
    }
  },
  render: function render(h, _ref) {
    var props = _ref.props,
        children = _ref.children;

    return h('div', { class: 'page-row', style: { marginBottom: props.margin + 'em' } }, [props.title && h('div', { class: "page-row__title" }, props.title), children]);
  }
});

/***/ }),

/***/ 11:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_home__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_docs__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_docs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pages_docs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_props__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_props___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pages_props__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_examples__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_examples___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__pages_examples__);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  // mode: 'history',
  // base: '/',
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return { selector: to.hash
        // } else if (savedPosition) {
        //   return savedPosition
      };
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes: [{
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_home___default.a
  }, {
    path: '/examples',
    name: 'Examples',
    component: __WEBPACK_IMPORTED_MODULE_5__pages_examples___default.a
  }, {
    path: '/docs',
    name: 'Docs',
    component: __WEBPACK_IMPORTED_MODULE_3__pages_docs___default.a
  }, {
    path: '/props',
    name: 'Props',
    component: __WEBPACK_IMPORTED_MODULE_4__pages_props___default.a
  }]
}));

/***/ }),

/***/ 12:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 16:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(30)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(19),
  /* template */
  __webpack_require__(222),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 17:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(20),
  /* template */
  __webpack_require__(221),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 18:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_uikit__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_uikit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_uikit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_uikit_dist_js_uikit_icons__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_uikit_dist_js_uikit_icons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_uikit_dist_js_uikit_icons__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_page_content__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_page_content___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_page_content__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_page_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_highlight_js_styles_agate_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_highlight_js_styles_agate_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_highlight_js_styles_agate_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_highlightjs__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_highlightjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_highlightjs__);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;



__WEBPACK_IMPORTED_MODULE_2_uikit___default.a.use(__WEBPACK_IMPORTED_MODULE_3_uikit_dist_js_uikit_icons___default.a);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component(__WEBPACK_IMPORTED_MODULE_5__components_page_content___default.a.name, __WEBPACK_IMPORTED_MODULE_5__components_page_content___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component(__WEBPACK_IMPORTED_MODULE_6__components_page_row__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_6__components_page_row__["a" /* default */]);


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_src__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component(__WEBPACK_IMPORTED_MODULE_7_src__["b" /* Modal */].name, __WEBPACK_IMPORTED_MODULE_7_src__["b" /* Modal */]);




// Tell Vue.js to use vue-highlightjs
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_9_vue_highlightjs___default.a);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App___default.a);
  }
});

/***/ }),

/***/ 19:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    ModalWrapper: __WEBPACK_IMPORTED_MODULE_0_src__["c" /* ModalWrapper */]
  }
});

/***/ }),

/***/ 20:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'page-content'
});

/***/ }),

/***/ 21:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__examples_modals_vmodal__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__examples_modals_vmodal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__examples_modals_vmodal__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'content-modal',
  components: {
    vModal: __WEBPACK_IMPORTED_MODULE_0__examples_modals_vmodal___default.a
  },
  props: {
    lorem: {
      type: Boolean,
      default: false
    },
    modal: {
      type: Boolean,
      default: false
    },
    escape: {
      type: Boolean,
      default: false
    },
    dismiss: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    openModal: function openModal() {
      this.$modals.open({
        component: __WEBPACK_IMPORTED_MODULE_0__examples_modals_vmodal___default.a,
        isBottom: true,
        isLeft: true,
        props: {
          header: true,
          footer: true
        }
      });
    }
  }
});

/***/ }),

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1.e289a36.png";

/***/ }),

/***/ 214:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(21),
  /* template */
  __webpack_require__(224),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(23),
  /* template */
  __webpack_require__(219),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(24),
  /* template */
  __webpack_require__(220),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 217:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(25),
  /* template */
  __webpack_require__(223),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(26),
  /* template */
  __webpack_require__(225),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 219:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "padding": "0 2em 2em"
    }
  }, [_c('p', [_vm._v("Variants")]), _vm._v(" "), _c('pre', {
    directives: [{
      name: "highlightjs",
      rawName: "v-highlightjs"
    }]
  }, [_c('code', {
    staticClass: "js",
    staticStyle: {
      "font-size": "0.9em",
      "padding": "1em"
    }
  }, [_vm._v(_vm._s(_vm.formatJS(_vm.variants)))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "0 2em 2em"
    }
  }, [_c('p', [_vm._v("Simple")]), _vm._v(" "), _c('pre', {
    directives: [{
      name: "highlightjs",
      rawName: "v-highlightjs"
    }]
  }, [_c('code', {
    staticClass: "js",
    staticStyle: {
      "font-size": "0.9em",
      "padding": "1em"
    }
  }, [_vm._v(_vm._s(_vm.formatJS(_vm.example1)))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "0 2em 2em"
    }
  }, [_c('p', [_vm._v("Custom")]), _vm._v(" "), _c('pre', {
    directives: [{
      name: "highlightjs",
      rawName: "v-highlightjs"
    }]
  }, [_c('code', {
    staticClass: "js",
    staticStyle: {
      "font-size": "0.9em",
      "padding": "1em"
    }
  }, [_vm._v(_vm._s(_vm.formatJS(_vm.example2)))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "0 2em 2em"
    }
  }, [_c('p', [_vm._v("Modal with the most simple component")]), _vm._v(" "), _c('pre', {
    directives: [{
      name: "highlightjs",
      rawName: "v-highlightjs"
    }]
  }, [_c('code', {
    staticClass: "js",
    staticStyle: {
      "font-size": "0.9em",
      "padding": "1em"
    }
  }, [_vm._v(_vm._s(_vm.formatJS(_vm.example3)))])])])])
},staticRenderFns: []}

/***/ }),

/***/ 22:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__static_avatars_1_png__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__static_avatars_1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__static_avatars_1_png__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'v-modal',
  props: {
    title: String,
    header: Boolean,
    footer: Boolean,
    closeCallback: {
      type: Boolean,
      default: false
    },
    lorem: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      avatar: __WEBPACK_IMPORTED_MODULE_0__static_avatars_1_png___default.a,
      isLorem: this.lorem
    };
  },

  methods: {
    closeBack: function closeBack() {
      this.$modals.close({ data: 'data' });
    },
    close: function close() {
      this.$modals.dismiss();
      // this.$emit('close', { test: 'data'})
    }
  }
});

/***/ }),

/***/ 220:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('page-row', {
    attrs: {
      "title": "Variant",
      "margin": 2
    }
  }, [_c('div', {
    staticClass: "uk-button-group"
  }, [_c('button', {
    staticClass: "uk-button uk-button-small uk-button-primary",
    on: {
      "click": function($event) {
        _vm.openModal(0)
      }
    }
  }, [_vm._v("Simple")]), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-small uk-button-primary",
    on: {
      "click": function($event) {
        _vm.openModal(1)
      }
    }
  }, [_vm._v("Long content")]), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-small uk-button-primary",
    on: {
      "click": function($event) {
        _vm.openModal(2)
      }
    }
  }, [_vm._v("Scroll")]), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-small uk-button-primary",
    on: {
      "click": function($event) {
        _vm.openModal(3)
      }
    }
  }, [_vm._v("Fullscreen")]), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-small uk-button-primary",
    on: {
      "click": function($event) {
        _vm.openModal(20)
      }
    }
  }, [_vm._v("Scroll & Fullscreen")])])]), _vm._v(" "), _c('page-row', {
    attrs: {
      "margin": 2,
      "title": "Position"
    }
  }, [_c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "uk-button-group"
  }, [_c('button', {
    staticClass: "uk-button uk-button-small uk-button-primary",
    on: {
      "click": function($event) {
        _vm.openModal(7)
      }
    }
  }, [_vm._v("top left")]), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-small uk-button-primary",
    on: {
      "click": function($event) {
        _vm.openModal(8)
      }
    }
  }, [_vm._v("top")]), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-small uk-button-primary",
    on: {
      "click": function($event) {
        _vm.openModal(9)
      }
    }
  }, [_vm._v("top right")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "uk-button-group"
  }, [_c('button', {
    staticClass: "uk-button uk-button-small uk-button-primary",
    on: {
      "click": function($event) {
        _vm.openModal(4)
      }
    }
  }, [_vm._v("left center")]), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-small uk-button-primary",
    on: {
      "click": function($event) {
        _vm.openModal(5)
      }
    }
  }, [_vm._v("center")]), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-small uk-button-primary",
    on: {
      "click": function($event) {
        _vm.openModal(6)
      }
    }
  }, [_vm._v("right center")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "uk-button-group"
  }, [_c('button', {
    staticClass: "uk-button uk-button-small uk-button-primary",
    on: {
      "click": function($event) {
        _vm.openModal(10)
      }
    }
  }, [_vm._v("bottom left")]), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-small uk-button-primary",
    on: {
      "click": function($event) {
        _vm.openModal(11)
      }
    }
  }, [_vm._v("bottom")]), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-small uk-button-primary",
    on: {
      "click": function($event) {
        _vm.openModal(12)
      }
    }
  }, [_vm._v("bottom right")])])])])]), _vm._v(" "), _c('page-row', {
    attrs: {
      "title": "Scroll with left/right position",
      "margin": 2
    }
  }, [_c('div', {
    staticClass: "uk-button-group"
  }, [_c('button', {
    staticClass: "uk-button uk-button-primary uk-button-small",
    on: {
      "click": function($event) {
        _vm.openModal(13)
      }
    }
  }, [_vm._v("Left")]), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-primary uk-button-small",
    on: {
      "click": function($event) {
        _vm.openModal(14)
      }
    }
  }, [_vm._v("Right")])])]), _vm._v(" "), _c('page-row', {
    attrs: {
      "title": "Header and footer slots",
      "margin": 2
    }
  }, [_c('div', {
    staticClass: "uk-button-group"
  }, [_c('button', {
    staticClass: "uk-button uk-button-small uk-button-primary",
    on: {
      "click": function($event) {
        _vm.openModal(15)
      }
    }
  }, [_vm._v("Header")]), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-small uk-button-primary",
    on: {
      "click": function($event) {
        _vm.openModal(16)
      }
    }
  }, [_vm._v("Footer")]), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-small uk-button-primary",
    on: {
      "click": function($event) {
        _vm.openModal(17)
      }
    }
  }, [_vm._v("Header & Footer")])])]), _vm._v(" "), _c('page-row', {
    attrs: {
      "title": "Callback",
      "margin": 2
    }
  }, [_c('div', {
    staticClass: "uk-button-group"
  }, [_c('button', {
    staticClass: "uk-button uk-button-primary uk-button-small",
    on: {
      "click": function($event) {
        _vm.openModal(18)
      }
    }
  }, [_vm._v("onDismiss")]), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-primary uk-button-small",
    on: {
      "click": function($event) {
        _vm.openModal(19)
      }
    }
  }, [_vm._v("onClose")])])]), _vm._v(" "), _c('page-row', {
    attrs: {
      "title": "Other",
      "margin": 2
    }
  }, [_c('div', {
    staticClass: "uk-button-group"
  }, [_c('button', {
    staticClass: "uk-button uk-button-primary uk-button-small",
    on: {
      "click": function($event) {
        _vm.openModal(21)
      }
    }
  }, [_vm._v("Multi modals")]), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-primary uk-button-small",
    on: {
      "click": function($event) {
        _vm.openModal(22)
      }
    }
  }, [_vm._v("Escapable")]), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-primary uk-button-small",
    on: {
      "click": function($event) {
        _vm.openModal(23)
      }
    }
  }, [_vm._v("Without dismiss by pressing the mask")])])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 221:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-content"
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 222:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('nav', {
    staticClass: "uk-navbar-container"
  }, [_c('div', {
    staticClass: "uk-navbar-left"
  }, [_c('ul', {
    staticClass: "uk-navbar-nav"
  }, [_c('li', {
    staticClass: "uk-active"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('b', [_vm._v("Vue-universal-modal")])])], 1), _vm._v(" "), _c('li', {}, [_c('router-link', {
    attrs: {
      "to": "/docs"
    }
  }, [_vm._v("Docs")])], 1), _vm._v(" "), _c('li', {}, [_c('router-link', {
    attrs: {
      "to": "/props"
    }
  }, [_vm._v("Props")])], 1), _vm._v(" "), _c('li', {}, [_c('router-link', {
    attrs: {
      "to": "/examples"
    }
  }, [_vm._v("Examples")])], 1), _vm._v(" "), _vm._m(0)])])]), _vm._v(" "), _c('page-content'), _vm._v(" "), _c('modal-wrapper')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://github.com/vuNemesis/vue-universal-modal"
    }
  }, [_c('span', {
    attrs: {
      "uk-icon": "github"
    }
  })])])
}]}

/***/ }),

/***/ 223:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n  In progress...\n")])
},staticRenderFns: []}

/***/ }),

/***/ 224:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.escape && _vm.dismiss) ? _c('div', [_vm._v("Press the "), _c('b', [_vm._v("Esc")]), _vm._v("-key to dismiss the modal")]) : _vm._e(), _vm._v(" "), (_vm.escape && !_vm.dismiss) ? _c('div', [_vm._v("Press the "), _c('b', [_vm._v("Esc")]), _vm._v("-key or "), _c('b', [_vm._v("Cancel")]), _vm._v("-button to dismiss the modal")]) : _vm._e(), _vm._v(" "), (!_vm.escape) ? _c('div', [_vm._v("\n    Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quia consequuntur minus sint quidem ut tenetur dicta sunt voluptates numquam. Eum totam ex maxime aut recusandae quae laborum fugit ab autem.\n    "), (_vm.lorem) ? [_c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quia consequuntur minus sint quidem ut tenetur dicta sunt voluptates numquam. Eum totam ex maxime aut recusandae quae laborum fugit ab autem.")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quia consequuntur minus sint quidem ut tenetur dicta sunt voluptates numquam. Eum totam ex maxime aut recusandae quae laborum fugit ab autem.")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quia consequuntur minus sint quidem ut tenetur dicta sunt voluptates numquam. Eum totam ex maxime aut recusandae quae laborum fugit ab autem.")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quia consequuntur minus sint quidem ut tenetur dicta sunt voluptates numquam. Eum totam ex maxime aut recusandae quae laborum fugit ab autem.")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quia consequuntur minus sint quidem ut tenetur dicta sunt voluptates numquam. Eum totam ex maxime aut recusandae quae laborum fugit ab autem.")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quia consequuntur minus sint quidem ut tenetur dicta sunt voluptates numquam. Eum totam ex maxime aut recusandae quae laborum fugit ab autem.")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quia consequuntur minus sint quidem ut tenetur dicta sunt voluptates numquam. Eum totam ex maxime aut recusandae quae laborum fugit ab autem.")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quia consequuntur minus sint quidem ut tenetur dicta sunt voluptates numquam. Eum totam ex maxime aut recusandae quae laborum fugit ab autem.")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quia consequuntur minus sint quidem ut tenetur dicta sunt voluptates numquam. Eum totam ex maxime aut recusandae quae laborum fugit ab autem.")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quia consequuntur minus sint quidem ut tenetur dicta sunt voluptates numquam. Eum totam ex maxime aut recusandae quae laborum fugit ab autem.")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quia consequuntur minus sint quidem ut tenetur dicta sunt voluptates numquam. Eum totam ex maxime aut recusandae quae laborum fugit ab autem.")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quia consequuntur minus sint quidem ut tenetur dicta sunt voluptates numquam. Eum totam ex maxime aut recusandae quae laborum fugit ab autem.")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quia consequuntur minus sint quidem ut tenetur dicta sunt voluptates numquam. Eum totam ex maxime aut recusandae quae laborum fugit ab autem.")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quia consequuntur minus sint quidem ut tenetur dicta sunt voluptates numquam. Eum totam ex maxime aut recusandae quae laborum fugit ab autem.")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quia consequuntur minus sint quidem ut tenetur dicta sunt voluptates numquam. Eum totam ex maxime aut recusandae quae laborum fugit ab autem.")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quia consequuntur minus sint quidem ut tenetur dicta sunt voluptates numquam. Eum totam ex maxime aut recusandae quae laborum fugit ab autem.")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quia consequuntur minus sint quidem ut tenetur dicta sunt voluptates numquam. Eum totam ex maxime aut recusandae quae laborum fugit ab autem.")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quia consequuntur minus sint quidem ut tenetur dicta sunt voluptates numquam. Eum totam ex maxime aut recusandae quae laborum fugit ab autem.")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quia consequuntur minus sint quidem ut tenetur dicta sunt voluptates numquam. Eum totam ex maxime aut recusandae quae laborum fugit ab autem.")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quia consequuntur minus sint quidem ut tenetur dicta sunt voluptates numquam. Eum totam ex maxime aut recusandae quae laborum fugit ab autem.")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quia consequuntur minus sint quidem ut tenetur dicta sunt voluptates numquam. Eum totam ex maxime aut recusandae quae laborum fugit ab autem.")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quia consequuntur minus sint quidem ut tenetur dicta sunt voluptates numquam. Eum totam ex maxime aut recusandae quae laborum fugit ab autem.")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quia consequuntur minus sint quidem ut tenetur dicta sunt voluptates numquam. Eum totam ex maxime aut recusandae quae laborum fugit ab autem.")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quia consequuntur minus sint quidem ut tenetur dicta sunt voluptates numquam. Eum totam ex maxime aut recusandae quae laborum fugit ab autem.")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quia consequuntur minus sint quidem ut tenetur dicta sunt voluptates numquam. Eum totam ex maxime aut recusandae quae laborum fugit ab autem.")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quia consequuntur minus sint quidem ut tenetur dicta sunt voluptates numquam. Eum totam ex maxime aut recusandae quae laborum fugit ab autem.")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quia consequuntur minus sint quidem ut tenetur dicta sunt voluptates numquam. Eum totam ex maxime aut recusandae quae laborum fugit ab autem.")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quia consequuntur minus sint quidem ut tenetur dicta sunt voluptates numquam. Eum totam ex maxime aut recusandae quae laborum fugit ab autem.")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quia consequuntur minus sint quidem ut tenetur dicta sunt voluptates numquam. Eum totam ex maxime aut recusandae quae laborum fugit ab autem.")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quia consequuntur minus sint quidem ut tenetur dicta sunt voluptates numquam. Eum totam ex maxime aut recusandae quae laborum fugit ab autem.")])] : _vm._e()], 2) : _vm._e(), _vm._v(" "), (!_vm.dismiss) ? _c('div', {
    staticStyle: {
      "margin-top": "2em"
    }
  }, [_c('button', {
    staticClass: "uk-button uk-button-smaller uk-button-primary",
    on: {
      "click": function($event) {
        _vm.$modals.dismiss()
      }
    }
  }, [_vm._v("Cancel")])]) : _vm._e(), _vm._v(" "), (_vm.modal) ? _c('div', {
    staticStyle: {
      "margin-top": "2em"
    }
  }, [_c('button', {
    staticClass: "uk-button uk-button-smaller uk-button-primary",
    on: {
      "click": _vm.openModal
    }
  }, [_vm._v("Open modal")])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 225:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "padding": "0 2em 2em"
    }
  }, [_c('h4', [_vm._v("Props for Modal component and for new modal options")]), _vm._v(" "), _c('table', {
    staticClass: "uk-table uk-table-divider uk-table-small uk-table-striped"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.properties), function(prop, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "uk-width-small"
    }, [_vm._v(_vm._s(prop.name))]), _vm._v(" "), _c('td', {
      staticClass: "uk-width-small"
    }, [_c('small', [_vm._v(_vm._s(prop.type))])]), _vm._v(" "), _c('td', {
      staticClass: "uk-width-small"
    }, [_vm._v(_vm._s(prop.default))]), _vm._v(" "), _c('td', {
      staticClass: "uk-width-small"
    }, [_vm._v(_vm._s(prop.accepted))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(prop.description))])])
  }))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "0 2em 2em"
    }
  }, [_c('h4', [_vm._v("Add props for new modal options")]), _vm._v(" "), _c('table', {
    staticClass: "uk-table uk-table-divider  uk-table-small"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.addProperties), function(prop, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "uk-width-small"
    }, [_vm._v(_vm._s(prop.name))]), _vm._v(" "), _c('td', {
      staticClass: "uk-width-small"
    }, [_c('small', [_vm._v(_vm._s(prop.type))])]), _vm._v(" "), _c('td', {
      staticClass: "uk-width-small"
    }, [_vm._v(_vm._s(prop.default))]), _vm._v(" "), _c('td', {
      staticClass: "uk-width-small"
    }, [_vm._v(_vm._s(prop.accepted))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(prop.description))])])
  }))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Property")]), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Default")]), _vm._v(" "), _c('th', [_vm._v("Accepted")]), _vm._v(" "), _c('th', [_vm._v("Description")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Property")]), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Default")]), _vm._v(" "), _c('th', [_vm._v("Accepted")]), _vm._v(" "), _c('th', [_vm._v("Description")])])])
}]}

/***/ }),

/***/ 226:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('vu-modal', {
    attrs: {
      "title": "Test modal",
      "isScroll": true,
      "size": "p50",
      "center": true,
      "escapable": true
    }
  }, [(_vm.header) ? _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "left",
      "align-items": "center"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('img', {
    attrs: {
      "src": _vm.avatar,
      "width": "30",
      "height": "30"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_vm._v("Basic modal")])]) : _vm._e(), _vm._v(" "), _c('div', [_c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quia consequuntur minus sint quidem ut tenetur dicta sunt voluptates numquam. Eum totam ex maxime aut recusandae quae laborum fugit ab autem.")]), _vm._v(" "), (_vm.isLorem) ? [_c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quia consequuntur minus sint quidem ut tenetur dicta sunt voluptates numquam. Eum totam ex maxime aut recusandae quae laborum fugit ab autem.")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quia consequuntur minus sint quidem ut tenetur dicta sunt voluptates numquam. Eum totam ex maxime aut recusandae quae laborum fugit ab autem.")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quia consequuntur minus sint quidem ut tenetur dicta sunt voluptates numquam. Eum totam ex maxime aut recusandae quae laborum fugit ab autem.")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quia consequuntur minus sint quidem ut tenetur dicta sunt voluptates numquam. Eum totam ex maxime aut recusandae quae laborum fugit ab autem.")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quia consequuntur minus sint quidem ut tenetur dicta sunt voluptates numquam. Eum totam ex maxime aut recusandae quae laborum fugit ab autem.")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quia consequuntur minus sint quidem ut tenetur dicta sunt voluptates numquam. Eum totam ex maxime aut recusandae quae laborum fugit ab autem.")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quia consequuntur minus sint quidem ut tenetur dicta sunt voluptates numquam. Eum totam ex maxime aut recusandae quae laborum fugit ab autem.")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quia consequuntur minus sint quidem ut tenetur dicta sunt voluptates numquam. Eum totam ex maxime aut recusandae quae laborum fugit ab autem.")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quia consequuntur minus sint quidem ut tenetur dicta sunt voluptates numquam. Eum totam ex maxime aut recusandae quae laborum fugit ab autem.")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quia consequuntur minus sint quidem ut tenetur dicta sunt voluptates numquam. Eum totam ex maxime aut recusandae quae laborum fugit ab autem.")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quia consequuntur minus sint quidem ut tenetur dicta sunt voluptates numquam. Eum totam ex maxime aut recusandae quae laborum fugit ab autem.")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quia consequuntur minus sint quidem ut tenetur dicta sunt voluptates numquam. Eum totam ex maxime aut recusandae quae laborum fugit ab autem.")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quia consequuntur minus sint quidem ut tenetur dicta sunt voluptates numquam. Eum totam ex maxime aut recusandae quae laborum fugit ab autem.")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quia consequuntur minus sint quidem ut tenetur dicta sunt voluptates numquam. Eum totam ex maxime aut recusandae quae laborum fugit ab autem.")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quia consequuntur minus sint quidem ut tenetur dicta sunt voluptates numquam. Eum totam ex maxime aut recusandae quae laborum fugit ab autem.")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quia consequuntur minus sint quidem ut tenetur dicta sunt voluptates numquam. Eum totam ex maxime aut recusandae quae laborum fugit ab autem.")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quia consequuntur minus sint quidem ut tenetur dicta sunt voluptates numquam. Eum totam ex maxime aut recusandae quae laborum fugit ab autem.")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quia consequuntur minus sint quidem ut tenetur dicta sunt voluptates numquam. Eum totam ex maxime aut recusandae quae laborum fugit ab autem.")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quia consequuntur minus sint quidem ut tenetur dicta sunt voluptates numquam. Eum totam ex maxime aut recusandae quae laborum fugit ab autem.")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quia consequuntur minus sint quidem ut tenetur dicta sunt voluptates numquam. Eum totam ex maxime aut recusandae quae laborum fugit ab autem.")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quia consequuntur minus sint quidem ut tenetur dicta sunt voluptates numquam. Eum totam ex maxime aut recusandae quae laborum fugit ab autem.")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quia consequuntur minus sint quidem ut tenetur dicta sunt voluptates numquam. Eum totam ex maxime aut recusandae quae laborum fugit ab autem.")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quia consequuntur minus sint quidem ut tenetur dicta sunt voluptates numquam. Eum totam ex maxime aut recusandae quae laborum fugit ab autem.")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quia consequuntur minus sint quidem ut tenetur dicta sunt voluptates numquam. Eum totam ex maxime aut recusandae quae laborum fugit ab autem.")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quia consequuntur minus sint quidem ut tenetur dicta sunt voluptates numquam. Eum totam ex maxime aut recusandae quae laborum fugit ab autem.")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quia consequuntur minus sint quidem ut tenetur dicta sunt voluptates numquam. Eum totam ex maxime aut recusandae quae laborum fugit ab autem.")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quia consequuntur minus sint quidem ut tenetur dicta sunt voluptates numquam. Eum totam ex maxime aut recusandae quae laborum fugit ab autem.")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quia consequuntur minus sint quidem ut tenetur dicta sunt voluptates numquam. Eum totam ex maxime aut recusandae quae laborum fugit ab autem.")])] : _vm._e()], 2), _vm._v(" "), (_vm.footer) ? _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.closeCallback) ? _c('button', {
    staticClass: "uk-button uk-button-smaller uk-button-primary",
    on: {
      "click": _vm.closeBack
    }
  }, [_vm._v("Close with onClose callback")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-smaller uk-button-primary",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Cancel")])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 23:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_beautify__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_beautify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_beautify__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'docs-page',
  methods: {
    formatJS: function formatJS(code) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_js_beautify__["js"])(code, {
        indent_size: 2,
        indent_char: ' ',
        wrap_attributes: 'auto',
        wrap_attributes_indent_size: 2,
        end_with_newline: false
      });
    },
    formatHTML: function formatHTML(code) {
      var preFormattedHTML = code.replace(/><(?!\/i|\/label|\/span|option)/g, '>\n<');
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_js_beautify__["html"])(preFormattedHTML, {
        indent_size: 2,
        indent_char: ' ',
        wrap_attributes: 'auto',
        wrap_attributes_indent_size: 2,
        end_with_newline: false
      });
    }
  },
  data: function data() {
    return {
      variants: '\n        // the following three options are available in any component\n        this.$modals.open(options)\n        this.$modals.$emit(\'new\', options)\n        this.$emit(\'modals:new\', options)\n\n        // the next option can be used anywhere, for this import the Bus from VueUniversalModal\n        Bus.$emit(\'new\', options) \n      ',
      example1: '\n        this.$modals.open({\n          title: \'Simple modal\',\n          component: Simple\n        })\n      ',
      example2: '\n        this.$modals.open({\n          title: \'Custom modal\',\n          component: Custom,\n          isScroll: true,\n          center: true,\n          size: \'p90\'\n        })\n      ',
      example3: '\n        this.$modals.open({\n          title: \'Custom modal\',\n          component: {\n            template: "<div>i\'m template :)</div>"\n          }\n        })\n      '

    };
  }
});

/***/ }),

/***/ 24:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__examples_modals_content__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__examples_modals_content___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__examples_modals_content__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__examples_modals_vmodal__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__examples_modals_vmodal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__examples_modals_vmodal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'examples-page',
  data: function data() {
    var modals = [{
      title: 'Simple modal',
      component: __WEBPACK_IMPORTED_MODULE_0__examples_modals_content___default.a
    }, {
      title: 'Long modal',
      component: __WEBPACK_IMPORTED_MODULE_0__examples_modals_content___default.a,
      props: {
        lorem: true
      }
    }, {
      title: 'Scroll modal',
      component: __WEBPACK_IMPORTED_MODULE_0__examples_modals_content___default.a,
      isScroll: true,
      props: {
        lorem: true
      }
    }, {
      title: 'Fullscreen modal',
      component: __WEBPACK_IMPORTED_MODULE_0__examples_modals_content___default.a,
      fullscreen: true,
      props: {
        lorem: true
      }
    }, {
      title: 'Left center position modal',
      component: __WEBPACK_IMPORTED_MODULE_0__examples_modals_content___default.a,
      isLeft: true,
      center: true
    }, {
      title: 'Center modal',
      component: __WEBPACK_IMPORTED_MODULE_0__examples_modals_content___default.a,
      center: true
    }, {
      title: 'Right center position modal',
      component: __WEBPACK_IMPORTED_MODULE_0__examples_modals_content___default.a,
      isRight: true,
      center: true
    }, {
      title: 'Top left position modal',
      component: __WEBPACK_IMPORTED_MODULE_0__examples_modals_content___default.a,
      isTop: true,
      isLeft: true
    }, {
      title: 'Top position modal',
      component: __WEBPACK_IMPORTED_MODULE_0__examples_modals_content___default.a,
      isTop: true
    }, {
      title: 'Top right position modal',
      component: __WEBPACK_IMPORTED_MODULE_0__examples_modals_content___default.a,
      isTop: true,
      isRight: true
    }, {
      title: 'Bottom left position modal',
      component: __WEBPACK_IMPORTED_MODULE_0__examples_modals_content___default.a,
      isBottom: true,
      isLeft: true
    }, {
      title: 'Bottom position modal',
      component: __WEBPACK_IMPORTED_MODULE_0__examples_modals_content___default.a,
      isBottom: true
    }, {
      title: 'Bottom right position modal',
      component: __WEBPACK_IMPORTED_MODULE_0__examples_modals_content___default.a,
      isBottom: true,
      isRight: true
    }, {
      title: 'Scroll left modal',
      component: __WEBPACK_IMPORTED_MODULE_0__examples_modals_content___default.a,
      isScroll: true,
      isLeft: true,
      props: {
        lorem: true
      }
    }, {
      title: 'Scroll right modal',
      component: __WEBPACK_IMPORTED_MODULE_0__examples_modals_content___default.a,
      isScroll: true,
      isRight: true,
      props: {
        lorem: true
      }
    }, {
      title: 'Custom header slot',
      component: __WEBPACK_IMPORTED_MODULE_1__examples_modals_vmodal___default.a,
      props: {
        header: true
      }
    }, {
      title: 'Custom footer slot',
      component: __WEBPACK_IMPORTED_MODULE_1__examples_modals_vmodal___default.a,
      props: {
        footer: true
      }
    }, {
      title: 'Custom header and footer slot',
      component: __WEBPACK_IMPORTED_MODULE_1__examples_modals_vmodal___default.a,
      props: {
        header: true,
        footer: true
      }
    }, {
      title: 'Callback onDismiss',
      component: __WEBPACK_IMPORTED_MODULE_1__examples_modals_vmodal___default.a,
      props: {
        footer: true
      },
      onDismiss: function onDismiss() {
        alert('onDismiss callback call!');
      }
    }, {
      title: 'Callback onClose',
      component: __WEBPACK_IMPORTED_MODULE_1__examples_modals_vmodal___default.a,
      props: {
        footer: true,
        closeCallback: true
      },
      onClose: function onClose() {
        alert('onClose callback call!');
      }
    }, {
      title: 'Fullscreen & Scroll modal',
      component: __WEBPACK_IMPORTED_MODULE_0__examples_modals_content___default.a,
      fullscreen: true,
      isScroll: true,
      props: {
        lorem: true
      }
    }, {
      title: 'Multi modal',
      component: __WEBPACK_IMPORTED_MODULE_0__examples_modals_content___default.a,
      props: {
        modal: true
      }
    }, {
      title: 'Escapable modal',
      component: __WEBPACK_IMPORTED_MODULE_0__examples_modals_content___default.a,
      escapable: true,
      center: true,
      props: {
        escape: true
      }
    }, {
      title: 'Without dismiss by pressing the mask',
      component: __WEBPACK_IMPORTED_MODULE_0__examples_modals_content___default.a,
      escapable: true,
      center: true,
      dismissable: false,
      props: {
        escape: true,
        dismiss: false
      }
    }];
    return {
      modals: modals
    };
  },
  created: function created() {
    // Bus.$on('new', options => {
    //   console.dir(options)
    // })
    // Bus.$on('opened', options => {
    //   console.dir(options)
    // })
    // this.$modals.$on('modals:opened', data => {
    //   console.log('opened ', data)
    // });
  },

  methods: {
    openModal: function openModal(index) {
      this.$modals.open(this.modals[index]);
      // this.$emit('modals:new', this.modals[index])
      // this.$modals.$emit('new', this.modals[index])
      // Bus.$emit('new', this.modals[index])
    }
  }
});

/***/ }),

/***/ 25:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'example-page'
});

/***/ }),

/***/ 26:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'props-page',
  data: function data() {
    return {
      addProperties: [{
        name: 'component',
        description: '',
        default: 'is required',
        type: 'Vue component',
        accepted: ''
      }, {
        name: 'onDismiss',
        description: '',
        default: '-',
        type: 'Function',
        accepted: ''
      }, {
        name: 'onClose',
        description: '',
        default: '-',
        type: 'Function',
        accepted: ''
      }],
      properties: [{
        name: 'title',
        description: '',
        default: '-',
        type: 'String',
        accepted: ''
      }, {
        name: 'size',
        description: '',
        default: 'md',
        type: 'String',
        accepted: 'xs, sm, md, lg, xl, p50, p70, p90'
      }, {
        name: 'className',
        description: '',
        default: '-',
        type: 'String',
        accepted: ''
      }, {
        name: 'fullscreen',
        description: '',
        default: 'false',
        type: 'Boolean',
        accepted: ''
      }, {
        name: 'center',
        description: '',
        default: 'false',
        type: 'Boolean',
        accepted: ''
      }, {
        name: 'isScroll',
        description: '',
        default: 'false',
        type: 'Boolean',
        accepted: ''
      }, {
        name: 'isTop',
        description: '',
        default: 'false',
        type: 'Boolean',
        accepted: ''
      }, {
        name: 'isBottom',
        description: '',
        default: 'false',
        type: 'Boolean',
        accepted: ''
      }, {
        name: 'isLeft',
        description: '',
        default: 'false',
        type: 'Boolean',
        accepted: ''
      }, {
        name: 'isRight',
        description: '',
        default: 'false',
        type: 'Boolean',
        accepted: ''
      }, {
        name: 'escapable',
        description: '',
        default: 'false',
        type: 'Boolean',
        accepted: ''
      }, {
        name: 'dismissable',
        description: '',
        default: 'true',
        type: 'Boolean',
        accepted: ''
      }, {
        name: 'bodyPadding',
        description: '',
        default: 'true',
        type: 'Boolean',
        accepted: ''
      }]
    };
  }
});

/***/ }),

/***/ 27:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'close-icon',
  functional: true,
  render: function render(h) {
    return h('svg', {
      attrs: {
        width: '12px',
        height: '12px',
        viewBox: '0 0 12 12',
        xmlSpace: 'preserve'
      }
    }, [h('line', {
      attrs: {
        x1: 1,
        y1: 11,
        x2: 11,
        y2: 1
      },
      style: {
        strokeLinecap: 'round',
        strokeLinejoin: 'round'
      }
    }), h('line', {
      attrs: {
        x1: 1,
        y1: 1,
        x2: 11,
        y2: 11
      },
      style: {
        strokeLinecap: 'round',
        strokeLinejoin: 'round'
      }
    })]);
  }
});

/***/ }),

/***/ 28:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_scss__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__style_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_bus__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modal__ = __webpack_require__(6);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vu-modal-wrapper',
  data: function data() {
    return {
      modals: []
    };
  },
  mounted: function mounted() {
    if (typeof document !== 'undefined') {
      document.body.addEventListener('keydown', this.handleTabKey);
    }

    if (typeof document !== 'undefined') {
      document.body.addEventListener('keyup', this.handleEscapeKey);
    }
  },
  destroyed: function destroyed() {
    if (typeof document !== 'undefined') {
      document.body.removeEventListener('keydown', this.handleTabKey);
    }

    if (typeof document !== 'undefined') {
      document.body.removeEventListener('keyup', this.handleEscapeKey);
    }
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__utils_bus__["a" /* default */].$on('new', function (options) {
      var defaults = {
        title: '',
        dismissable: true,
        center: false,
        fullscreen: false,
        isTop: false,
        isBottom: false,
        isLeft: false,
        isRight: false,
        isScroll: false,
        className: '',
        size: 'md',
        escapable: false,
        bodyPadding: true,
        onClose: function onClose() {},
        onDismiss: function onDismiss() {}
      };

      var instance = {};
      var rendered = void 0;
      if (options.component.template) {
        rendered = false;
      } else {
        rendered = options.component.render.call(_this, _this.$createElement);
      }

      if (rendered && rendered.componentOptions && rendered.componentOptions.Ctor.extendOptions.componentName === 'vu-modal') {
        var propsData = rendered.componentOptions.propsData;
        instance = {
          isVmodal: true,
          options: Object.assign(defaults, propsData, options)
        };
      } else {
        instance = {
          isVmodal: false,
          options: Object.assign(defaults, options)
        };
      }
      rendered = null;

      _this.modals.push(instance);

      __WEBPACK_IMPORTED_MODULE_1__utils_bus__["a" /* default */].$emit('opened', {
        index: _this.$last,
        instance: instance
      });

      _this.body && _this.body.classList.add('modals-open');
    });

    __WEBPACK_IMPORTED_MODULE_1__utils_bus__["a" /* default */].$on('close', function (data) {
      var index = null;

      if (data && data.$index) index = data.$index;

      if (index === null) index = _this.$last;

      _this.close(data, index);
    });

    __WEBPACK_IMPORTED_MODULE_1__utils_bus__["a" /* default */].$on('dismiss', function (index) {
      if (index === null) index = _this.$last;

      _this.dismiss(index);
    });
  },

  methods: {
    splice: function splice() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (index === -1) return;

      if (!this.modals.length) return;

      if (index === null) this.modals.pop();else this.modals.splice(index, 1);

      if (!this.modals.length) {
        this.body && this.body.classList.remove('modals-open');
        __WEBPACK_IMPORTED_MODULE_1__utils_bus__["a" /* default */].$emit('destroyed');
      }
    },
    doClose: function doClose(index) {
      if (!this.modals.length) return;

      if (!this.modals[index]) return;

      this.splice(index);
    },
    close: function close() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (this.modals.length === 0) return;

      var localIndex = index;

      if (index && typeof index === 'function') {
        localIndex = index(data, this.modals);
      }

      if (typeof localIndex !== 'number') localIndex = this.$last;

      __WEBPACK_IMPORTED_MODULE_1__utils_bus__["a" /* default */].$emit('closed', {
        index: localIndex,
        instance: this.modals[index],
        data: data
      });

      if (localIndex !== false && this.modals[localIndex]) {
        if (this.modals[localIndex].options.onClose(data) === false) {
          return;
        }
      }
      this.doClose(localIndex);
    },
    dismiss: function dismiss() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var localIndex = index;

      if (index && typeof index === 'function') localIndex = index(this.$last);

      if (typeof localIndex !== 'number') localIndex = this.$last;

      if (this.modals[localIndex].options.onDismiss() === false) return;

      __WEBPACK_IMPORTED_MODULE_1__utils_bus__["a" /* default */].$emit('dismissed', {
        index: localIndex,
        instance: this.modals[localIndex]
      });

      this.doClose(localIndex);
    },
    handleTabKey: function handleTabKey(e) {
      if (e.keyCode === 9 && this.modals.length) {
        e.preventDefault();
      }
    },
    handleEscapeKey: function handleEscapeKey(e) {
      if (e.keyCode === 27 && this.modals.length) {
        if (!this.modals.length) return;
        if (this.current.options.escapable) this.dismiss();
      }
    }
  },
  computed: {
    current: function current() {
      return this.modals[this.$last];
    },
    $last: function $last() {
      return this.modals.length - 1;
    },
    body: function body() {
      if (typeof document !== 'undefined') {
        return document.querySelector('body');
      }
    },
    wrapperStyle: function wrapperStyle() {
      return {
        'z-index': 5000 + this.$last + 1
      };
    }
  },
  render: function render(h) {
    var _this2 = this;

    if (!this.modals.length) {
      return null;
    };

    var modals = this.modals.map(function (modal, index) {
      var modalComponent = void 0;

      if (modal.isVmodal) {
        modalComponent = h(modal.options.component, {
          props: Object.assign({}, { vModal: Object.assign(modal.options, { disabled: index != _this2.$last }) }, modal.options.props)
        });
      } else {
        modalComponent = h(__WEBPACK_IMPORTED_MODULE_2__modal__["a" /* default */], {
          props: Object.assign(modal.options, { disabled: index != _this2.$last })
        }, [h(modal.options.component, {
          props: modal.options.props
        })]);
      }
      return h('div', {
        class: ['vu-modal__mask', { 'vu-modal__mask--disabled': index != _this2.$last }],
        on: { click: function click() {
            modal.options.dismissable && _this2.dismiss();
          } },
        key: index
      }, [modalComponent]);
    });

    return h('div', {
      class: 'vu-modal__wrapper'
    }, [modals]);
  }
});

/***/ }),

/***/ 29:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 30:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 6:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__close_icon__ = __webpack_require__(27);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vu-modal',
  componentName: 'vu-modal',
  props: {
    title: {
      type: String,
      default: ''
    },
    className: {
      type: String,
      default: ''
    },
    isScroll: {
      type: Boolean,
      default: false
    },
    escapable: {
      type: Boolean,
      default: false
    },
    dismissable: {
      type: Boolean,
      default: true
    },
    fullscreen: {
      type: Boolean,
      default: false
    },
    isTop: {
      type: Boolean,
      default: false
    },
    isBottom: {
      type: Boolean,
      default: false
    },
    isLeft: {
      type: Boolean,
      default: false
    },
    isRight: {
      type: Boolean,
      default: false
    },
    center: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'md'
    },
    bodyPadding: {
      type: Boolean,
      default: true
    }
  },
  mounted: function mounted() {
    if (this.$el.focus) {
      this.$el.focus();
    }
  },

  computed: {
    propsData: function propsData() {
      return this.$parent.$vnode.data.props && this.$parent.$vnode.data.props.vModal ? this.$parent.$vnode.data.props.vModal : this.$props;
    }
  },
  render: function render(h) {
    var _this = this;

    var _propsData = this.propsData,
        dismissable = _propsData.dismissable,
        title = _propsData.title,
        isScroll = _propsData.isScroll,
        fullscreen = _propsData.fullscreen,
        isTop = _propsData.isTop,
        isBottom = _propsData.isBottom,
        isLeft = _propsData.isLeft,
        isRight = _propsData.isRight,
        center = _propsData.center,
        size = _propsData.size,
        className = _propsData.className,
        bodyPadding = _propsData.bodyPadding;


    var closeBtn = dismissable ? h('div', {
      class: 'vu-modal__close-btn',
      on: {
        click: function click() {
          _this.$modals.dismiss();
        }
      }
    }, [h(__WEBPACK_IMPORTED_MODULE_0__close_icon__["a" /* default */])]) : null;

    var headerContent = this.$slots.header ? this.$slots.header : title ? h('span', { class: ['vu-modal__cmp-header-title'] }, title) : null;

    var header = headerContent ? h('div', {
      class: ['vu-modal__cmp-header']
    }, [headerContent]) : null;

    var body = h('div', {
      class: ['vu-modal__cmp-body'],
      style: {
        overflowY: isScroll ? 'auto' : null,
        padding: bodyPadding ? '1em' : 0
      }
    }, [this.$slots.default]);

    var footer = this.$slots.footer ? h('div', {
      class: ['vu-modal__cmp-footer']
    }, [this.$slots.footer]) : null;

    var style = {};
    var translateX = '-50%';
    var translateY = '0';
    if (center) {
      translateX = '-50%';
      translateY = '-50%';
    }
    if (isRight || isLeft) {
      translateX = '0%';
    }

    if ((isTop || isBottom) && !isScroll && !center) {
      translateY = '0%';
    }
    style.transform = 'translate(' + translateX + ', ' + translateY + ')';

    return h('div', {
      style: style,
      attrs: { tabindex: -1 },
      class: ['vu-modal__cmp', {
        'vu-modal__cmp--is-fullscreen': fullscreen,
        'vu-modal__cmp--is-center': center,
        'vu-modal__cmp--is-top': isTop && !isScroll && !center,
        'vu-modal__cmp--is-bottom': isBottom && !isScroll && !center,
        'vu-modal__cmp--is-left': isLeft,
        'vu-modal__cmp--is-right': isRight
      }, isScroll && fullscreen && 'vu-modal__cmp--is-scroll-fullscreen', isScroll && !fullscreen && 'vu-modal__cmp--is-scroll', !fullscreen && 'vu-modal__cmp--' + size, className],
      on: { click: function click(event) {
          event.stopPropagation();
        } }
    }, [closeBtn, header, body, footer]);
  }
});

/***/ }),

/***/ 7:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var instance = null;

var EventBus = function () {
  function EventBus() {
    _classCallCheck(this, EventBus);

    if (!instance) {
      this.events = {};
      instance = this;
    }
    return instance;
  }

  _createClass(EventBus, [{
    key: "$emit",
    value: function $emit(event, message) {
      if (!this.events[event]) return;
      var callbacks = this.events[event];
      for (var i = 0, l = callbacks.length; i < l; i++) {
        var callback = callbacks[i];
        callback.call(this, message);
      }
    }
  }, {
    key: "$on",
    value: function $on(event, callback) {
      if (!this.events[event]) this.events[event] = [];
      this.events[event].push(callback);
    }
  }]);

  return EventBus;
}();

/* harmony default export */ __webpack_exports__["a"] = (new EventBus());

/***/ }),

/***/ 9:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(22),
  /* template */
  __webpack_require__(226),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

},[18]);


// WEBPACK FOOTER //
// static/js/app.3ea48f7cca359e904af7.js